import { Modal, Form, Input, Button } from "antd";
import Draggable from "react-draggable";

import FormInputRules from "../../../util/FormInputRules";
import { formItemLayout, inputLayout } from "../../../constants/ApplicationConstants/FormConstants";
import { General } from "../../../util/General";
import CircularProgressBar from "../../common/CircularProgressBar";
import { useReactDraggable } from "../../../hooks/useReactDraggable";
import { ErrorMessageConstants } from "../../../constants/MessageConstants/ErrorMessageConstants";

type ResetPasswordByAdminProps = {
  showResetModal: boolean;
  handleSubmitResetPassword: (data: { newPassword: string; confirmPassword: string }) => Promise<void>;
  handleCancelResetPassword: () => void;
  saving: boolean;
};

const ResetPasswordByAdmin = (props: ResetPasswordByAdminProps) => {
  /* CONSTANTS */
  const [form] = Form.useForm();

  const { bounds, onStart } = useReactDraggable();

  return (
    <Modal
      afterClose={() => form.resetFields()}
      destroyOnClose={true}
      maskClosable={false}
      centered
      title={<div className="modal-container">{`Reset Password`}</div>}
      open={props.showResetModal}
      onCancel={props.handleCancelResetPassword}
      width={"50%"}
      okButtonProps={{
        style: {
          display: "none"
        }
      }}
      cancelButtonProps={{ style: { display: "none" } }}
      modalRender={(modal) => (
        <Draggable bounds={bounds} handle=".ant-modal-header" onStart={(event, uiData) => onStart(event as any, uiData)}>
          {modal}
        </Draggable>
      )}
    >
      <Form
        style={{
          marginTop: "0.2rem",
          paddingBottom: "5rem",
          paddingTop: "2rem"
        }}
        {...formItemLayout}
        form={form}
        validateTrigger="onBlur"
        colon={false}
        onFinish={props.handleSubmitResetPassword}
      >
        <Form.Item {...inputLayout} initialValue={null} name="newPassword" normalize={General.inputWhiteSpaceRemove} label="New Password" hasFeedback rules={[FormInputRules.requiredFieldInputRule("new password"), ...FormInputRules.getStrongPasswordRule()]}>
          <Input.Password autoComplete="new-password" placeholder="New Password" type="password" name="newPassword" onCopy={(e) => e.preventDefault()} />
        </Form.Item>

        <Form.Item
          {...inputLayout}
          initialValue={null}
          name="confirmPassword"
          label="Confirm Password"
          normalize={General.inputWhiteSpaceRemove}
          hasFeedback
          rules={[
            FormInputRules.requiredFieldInputRule("confirm password"),
            ({ getFieldValue }) => ({
              validator(rule, value) {
                if (!value || getFieldValue("newPassword") === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error(ErrorMessageConstants.NEW_AND_CONFIRM_PASSWORD_DO_NOT_MATCH));
              }
            })
          ]}
        >
          <Input.Password autoComplete="new-password" placeholder="Confirm Password" type="password" name="confirmPassword" onCopy={(e) => e.preventDefault()} />
        </Form.Item>

        <Form.Item
          style={{
            float: "right",
            marginTop: "20px"
          }}
        >
          <Button className="gx-mb-0 button-gradiant" htmlType="submit" style={{ margin: "0rem 1rem" }}>
            {props.saving ? <CircularProgressBar /> : "Submit"}
          </Button>
        </Form.Item>

        <Form.Item
          style={{
            float: "right",
            marginTop: "20px"
          }}
        >
          <Button disabled={props.saving} style={{ margin: "0rem 1rem" }} className="gx-mb-0 button-gradiant" onClick={props.handleCancelResetPassword}>
            Close
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ResetPasswordByAdmin;
